export default "__VITE_ASSET__bb99fd10__"